import parse from 'react-html-parser';
import type { ReactElement } from 'react';
import type { ProductDetailProduct } from '../api/products/productDetail';
import type { SupportedLocale } from '../i18n/types';

export function getProductDescription(
  product: Pick<ProductDetailProduct, 'description'>,
  locale: SupportedLocale,
): ReactElement[] | null {
  if (!product || !product.description || !product.description.length) return null;

  const description = product.description.find((d) => d.language === locale)?.text;
  if (description) return parse(description);
  if (locale === 'cs') return null;

  const csDescription = product.description.find((d) => d.language === 'cs')?.text;
  if (csDescription) return parse(csDescription);
  return null;
}
